// This file is auto-generated by @hey-api/openapi-ts

export const tagTypes = [
  'assignments',
  'messages',
  'routes',
  'what-time-is-it',
  'public',
  'trips',
  'Authentication',
  'Organizations',
  'Payers',
  'Trips',
  'Webhooks',
  'developer-platform',
  'attendants',
  'billing',
  'dispatch',
  'drivers',
  'invoices',
  'members',
  'organizations',
  'passengers',
  'payers',
  'preferred-drivers',
  'run-bambi-run',
  'tags',
  'tilled',
  'user',
  'vehicles',
  'brokers',
  'CTC',
  'credentials',
  'daily-digest',
  'die',
  'files',
  'filters',
  'flags',
  'internal',
  'itinerary',
  'locations',
  'notifications',
  'organization-billing-status',
  'organization-billing-status-settings',
  'Drivers',
  'Vehicles',
  'passenger-import',
  'pricing',
  'reports',
  'signatures',
  'trip-import',
  'trip-request-embed',
  'web-push-subscription',
] as const;
